var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"streams-schedule"},[_c('h1',{staticClass:"streams-schedule__title"},[_vm._v("Transliacijos")]),_c('Navigation',{attrs:{"date":_vm.date},on:{"set-date":_vm.handleSetDate}}),_c('Schedule',{attrs:{"schedule":_vm.schedule}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }